import { Typography, Paper } from '@mui/material'
import { useTranslation } from 'react-i18next'
import CheckDetailTitle from './CheckDetailTitle'
import TimelineDotLine from '../components/TimelineDotLine'
import CheckRiskStatus from '../components/CheckRiskStatus'
import { BDC_convertLevelToHumanFriendly } from '../../../../../components/utilities/formatters/negativeMedia'
  

const CheckNegativeMedia = ({ negativeMediaCheck }) => {
  const { t } = useTranslation(['common', 'messages'])
  const source1 = negativeMediaCheck?.checkDetails?.source1 || {}
  const source2 = negativeMediaCheck?.checkDetails?.source2
  const stats = source1?.EntityStatistics?.NewsByRangeDate
  const newsSource1 = Array.isArray(source1?.NewsItems) ? source1.NewsItems : []
  const newsSource2 =
    source2?.data?.[0]?.resultados && Array.isArray(source2.data[0].resultados) ? source2.data[0].resultados : []

  const hasChecks = negativeMediaCheck?.checkDetails && Object.keys(negativeMediaCheck?.checkDetails).length > 0
  const checkLength = hasChecks ? 1 : 0

  return (
    <>
      <Paper elevation={0} variant="colorPrimary" sx={{ display: 'flex', justifyContent: 'space-between' }}>
        <Typography>{t('common:negativeMedia')}</Typography>
        <CheckRiskStatus checkLength={checkLength} hasChecks={hasChecks} />
      </Paper>

      <CheckDetailTitle
        email={negativeMediaCheck?.email}
        status={negativeMediaCheck?.status}
        createdAt={negativeMediaCheck?.createdAt}
        updatedAt={negativeMediaCheck?.updatedAt}
      />

      {hasChecks && (
        <TimelineDotLine>
          <Paper variant="rootOutlined" elevation={0} sx={{ flex: 1 }}>
            <div className="c-detail-grid">
              <div className="c-detail-row">
                <Typography variant="subtitle1">{t('common:mediaExposureLevel')}</Typography>
                <Typography variant="subtitle3">{BDC_convertLevelToHumanFriendly(source1?.MediaExposureLevel, t )}</Typography>
              </div>
              <div className="c-detail-row">
                <Typography variant="subtitle1">{t('common:celebrityLevel')}</Typography>
                <Typography variant="subtitle3">{BDC_convertLevelToHumanFriendly(source1?.CelebrityLevel, t)}</Typography>
              </div>
              <div className="c-detail-row">
                <Typography variant="subtitle1">{t('common:unpopularityLevel')}</Typography>
                <Typography variant="subtitle3">{BDC_convertLevelToHumanFriendly(source1?.UnpopularityLevel, t)}</Typography>
              </div>
              <div className="c-detail-row">
                <Typography variant="subtitle1">{t('common:totalNews')}</Typography>
                <Typography variant="subtitle3">{stats?.TotalNews ?? '---'}</Typography>
              </div>
              <div className="c-detail-row">
                <Typography variant="subtitle1">
                  {t('common:totalNews')} {t('common:last7')}
                </Typography>
                <Typography variant="subtitle3">{stats?.TotalNewsOnLast7Days ?? '---'}</Typography>
              </div>
              <div className="c-detail-row">
                <Typography variant="subtitle1">
                  {t('common:totalNews')} {t('common:last30')}
                </Typography>
                <Typography variant="subtitle3">{stats?.TotalNewsOnLast30Days ?? '---'}</Typography>
              </div>
              <div className="c-detail-row">
                <Typography variant="subtitle1">
                  {t('common:totalNews')} {t('common:last90')}
                </Typography>
                <Typography variant="subtitle3">{stats?.TotalNewsOnLast90Days ?? '---'}</Typography>
              </div>
              <div className="c-detail-row">
                <Typography variant="subtitle1">
                  {t('common:totalNews')} {t('common:last180')}
                </Typography>
                <Typography variant="subtitle3">{stats?.TotalNewsOnLast180Days ?? '---'}</Typography>
              </div>
              <div className="c-detail-row">
                <Typography variant="subtitle1">
                  {t('common:totalNews')} {t('common:last365')}
                </Typography>
                <Typography variant="subtitle3">{stats?.TotalNewsOnLast365Days ?? '---'}</Typography>
              </div>
              <div style={{ gridColumn: '1 / 3' }}>
                {source1?.informação && (
                  <div className="c-detail-row">
                    <Typography variant="subtitle1">{t('common:information')}</Typography>
                    <Typography variant="subtitle3">{source1.informação}</Typography>
                  </div>
                )}
                <div className="c-detail-row">
                  {newsSource1.length > 0 && (
                    <div className="c-detail-col" style={{ width: '100%' }}>
                      <Typography variant="subtitle1">{t('common:kyb.checks.negativeMedia.source1.title')}</Typography>
                      <ul style={{ paddingLeft: '1rem' }}>
                        {newsSource1.map((item, idx) => (
                          <li key={idx}>
                            <a href={item.Url} target="_blank" rel="noreferrer">
                              {item.Title ?? '---'}
                            </a>
                            - <Typography variant="subtitle3">{item.SourceName}</Typography>
                          </li>
                        ))}
                      </ul>
                    </div>
                  )}
                  {newsSource2.length > 0 && (
                    <div className="c-detail-col" style={{ width: '100%' }}>
                      <Typography variant="subtitle1">{t('common:kyb.checks.negativeMedia.source2.title')}</Typography>
                      <ul style={{ paddingLeft: '1rem' }}>
                        {newsSource2?.map((item, idx) => (
                          <li key={idx}>
                            <a href={item.url} target="_blank" rel="noreferrer">
                              {item.titulo ?? '---'}
                            </a>
                            <Typography variant="subtitle3">{item.descricao ? ` - ${item.descricao}` : ''}</Typography>
                          </li>
                        ))}
                      </ul>
                    </div>
                  )}
                </div>
              </div>
            </div>
          </Paper>
        </TimelineDotLine>
      )}
    </>
  )
}

export default CheckNegativeMedia

/* import { Box, Typography } from '@mui/material'
import { useTranslation } from 'react-i18next'
import CheckDetailTitle from './CheckDetailTitle'

const variantByLevel = {
  0: 'h3',
  1: 'h4',
}

const CheckNegativeMedia = ({ title = '', negativeMediaCheck, level = 0 }) => {
  const { t } = useTranslation(['common', 'messages'])
  return (
    <Box className="detail-group">
      <Typography variant={variantByLevel[level] || variantByLevel[0]}>{title || t('common:negativeMedia')}</Typography>
      <CheckDetailTitle
        email={negativeMediaCheck.email}
        status={negativeMediaCheck.status}
        createdAt={negativeMediaCheck.createdAt}
        updatedAt={negativeMediaCheck.updatedAt}
      />
      <Box className="">
        <h4>{t('common:negativeMediaDetails')}</h4>
        <Box className="detail-group-grid-3">
          <Box>
            <span>{t('common:mediaExposureLevel')}</span>
            <p>{negativeMediaCheck?.checkDetails?.source1?.MediaExposureLevel ?? '---'}</p>
          </Box>
          <Box>
            <span>{t('common:celebrityLevel')}</span>
            <p>{negativeMediaCheck?.checkDetails?.source1?.CelebrityLevel ?? '---'}</p>
          </Box>
          <Box>
            <span>{t('common:unpopularityLevel')}</span>
            <p>{negativeMediaCheck?.checkDetails?.source1?.UnpopularityLevel ?? '---'}</p>
          </Box>
          <Box>
            <span>{t('common:totalNews')}</span>
            <p>{negativeMediaCheck?.checkDetails?.source1?.EntityStatistics?.NewsByRangeDate?.TotalNews ?? '---'}</p>
          </Box>
          <Box>
            <span>
              {t('common:totalNews')} {t('common:last7')}
            </span>
            <p>
              {negativeMediaCheck?.checkDetails?.source1?.EntityStatistics?.NewsByRangeDate?.TotalNewsOnLast7Days ??
                '---'}
            </p>
          </Box>
          <Box>
            <span>
              {t('common:totalNews')} {t('common:last30')}
            </span>
            <p>
              {negativeMediaCheck?.checkDetails?.source1?.EntityStatistics?.NewsByRangeDate?.TotalNewsOnLast30Days ??
                '---'}
            </p>
          </Box>
          <Box>
            <span>
              {t('common:totalNews')} {t('common:last90')}
            </span>
            <p>
              {negativeMediaCheck?.checkDetails?.source1?.EntityStatistics?.NewsByRangeDate?.TotalNewsOnLast90Days ??
                '---'}
            </p>
          </Box>
          <Box>
            <span>
              {t('common:totalNews')} {t('common:last180')}
            </span>
            <p>
              {negativeMediaCheck?.checkDetails?.source1?.EntityStatistics?.NewsByRangeDate?.TotalNewsOnLast180Days ??
                '---'}
            </p>
          </Box>
          <Box>
            <span>
              {t('common:totalNews')} {t('common:last365')}
            </span>
            <p>
              {negativeMediaCheck?.checkDetails?.source1?.EntityStatistics?.NewsByRangeDate?.TotalNewsOnLast365Days ??
                '---'}
            </p>
          </Box>
        </Box>
        {negativeMediaCheck?.checkDetails?.source1?.informação && (
          <Box>
            <span>{t('common:information')}</span>
            <p>{negativeMediaCheck?.checkDetails?.source1?.informação}</p>
          </Box>
        )}
      </Box>
    </Box>
  )
}

export default CheckNegativeMedia
 */
